import React, { useState, useEffect } from 'react'
import { Form, Input, InputNumber, Radio, Space } from 'antd'
import { MaskedInput } from 'antd-mask-input'

const SettingsPool = (props) => {
  const [poolPromotion, setPoolPromotion] = useState()

  useEffect(() => {
    setPoolPromotion(props?.initialValues?.[`pool_promotion_${[props?.index]}`])
  }, [props.tournament, props.initialValues])

  const onPoolPromotionUpdate = (e) => {
    setPoolPromotion(e.target.value)
  }

  // don't bother rendering this unless we have a value
  if (['all', 'number'].includes(poolPromotion)) {
    return (
      <>
        <Form.Item label='Name' name={`pool_name_${props.index}`} hidden={props.hidden} initialValue={`Qualifiers #${props.schedule.reduce((total, x) => (x === 'pools' ? total + 1 : total), 0)}`}>
          <Input />
        </Form.Item>
        <Form.Item label='Max Score' name={`pool_score_${props.index}`} hidden={props.hidden} initialValue={8}>
          <InputNumber />
        </Form.Item>
        <Form.Item label='Max Bout Time' name={`pool_duration_${props.index}`} hidden={props.hidden} initialValue='01:30'>
          <MaskedInput mask='0[0]:0[0]' className='duration' />
        </Form.Item>
        <Form.Item label='Qualified' name={`pool_promotion_${props.index}`} hidden={props.hidden} initialValue={poolPromotion}>
          <Radio.Group name={props.index} onChange={onPoolPromotionUpdate} value={poolPromotion} style={{ width: '100%' }}>
            <Space direction='vertical'>
              <Radio value='all'>100%</Radio>
              <Radio value='number'>Number</Radio>
            </Space>
          </Radio.Group>
        </Form.Item>
        {
          poolPromotion === 'number'
            ? (
              <Form.Item name={`pool_promotion_exact_${props.index}`} wrapperCol={{ offset: 8, span: 16 }} hidden={props.hidden} initialValue={8}>
                <Input style={{ width: '4em' }} />
              </Form.Item>
              )
            : null
        }
      </>
    )
  } else {
    return (<></>)
  }
}

export default SettingsPool
